
import { useState } from 'react';
import { BrowserRouter } from "react-router-dom";
import { AppRoutes } from "./router";
import Navbar from "./components/feature/Navbar";
import { BuscaProjetosContext } from "./hooks/useBuscaProjetos";

function App() {
  const [termoBusca, setTermoBusca] = useState('');
  const [buscaAberta, setBuscaAberta] = useState(false);

  return (
    <BuscaProjetosContext.Provider value={{ termoBusca, setTermoBusca, buscaAberta, setBuscaAberta }}>
      <BrowserRouter basename={__BASE_PATH__}>
        <Navbar />
        <AppRoutes />
      </BrowserRouter>
    </BuscaProjetosContext.Provider>
  );
}

export default App;
